export const GOODS_TYPE = {
  // 굿즈
  MPS: 'MPS',

  // 크리에이터 상품
  PBG: 'PBG',

  // 디지털/전자책
  DTG: 'DTG',

  // 입고 상품
  TPL: 'TPL',
} as const;

export type GoodsTypeId = keyof typeof GOODS_TYPE;
